import React, { useState } from 'react';
import styled from 'styled-components';

import { ICON_CLOSE, ICON_NOTICE_RED } from 'assets/icons';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import Row from 'components/common/Row';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import CommonImage from 'components/common/CommonImage';
import { useNavigate } from 'react-router-dom';
import { SETTLEMENT_LIST_PATH } from 'constants/path';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  width: 100%;

  border-radius: 12px;
  border: 1px solid rgba(255, 66, 66, 0.4);
  background: rgba(255, 66, 66, 0.08);
`;

const NoticeContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style-position: outside;
  padding: 12px 20px 32px;

  li {
    margin-left: 20px;
  }
`;

const SubNoticeContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style-position: outside;
  padding: 0px;

  li {
    color: #989ba2;
  }
`;

interface SettlemnetFailedContainerIProps {
  isMobile: boolean;
  type?: string;
}

const SettlementFailedContainer: React.FC<
  SettlemnetFailedContainerIProps
> = props => {
  const { isMobile, type } = props;
  const navigate = useNavigate();

  const [isOpenNoticeModal, setIsOpenNoticeModal] = useState<boolean>(false);

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <Container>
          <img
            src={ICON_NOTICE_RED}
            alt="icon notice red"
            style={{ width: '28px' }}
          />
          <Column align="flex-start" gap="12px">
            <Column align="flex-start" gap="4px">
              <Text color="#1b1c1e" weight={600}>
                1개 주차만 따로 정산 요청할 수 없어요.
              </Text>
              <Text color="#46474c" size="13px" weight={400}>
                미지급 상태의 마이너스(회수) 정산서가 있는 경우, 1개 주차만 따로
                정산 요청할 수 없어요.
              </Text>
            </Column>
            <Text
              color="#1b1c1e"
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                setIsOpenNoticeModal(true);
              }}
            >
              확인하기
            </Text>
          </Column>
        </Container>
      );
    }

    return (
      <Container>
        <img
          src={ICON_NOTICE_RED}
          alt="icon notice red"
          style={{ width: '28px' }}
        />
        <Row style={{ width: '100%' }}>
          <Column align="flex-start" gap="4px">
            <Text color="#1b1c1e" weight={600}>
              1개 주차만 따로 정산 요청할 수 없어요.
            </Text>
            <Text color="#46474c" size="13px" weight={400}>
              미지급 상태의 마이너스(회수) 정산서가 있는 경우, 1개 주차만 따로
              정산 요청할 수 없어요.
            </Text>
          </Column>
          <Text
            color="#1b1c1e"
            style={{
              minWidth: '50px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              setIsOpenNoticeModal(true);
            }}
          >
            확인하기
          </Text>
        </Row>
      </Container>
    );
  };

  const renderNoticeModal = (): JSX.Element => {
    return (
      <ModalContainer
        isMobile={isMobile}
        isAbled={true}
        onCloseText=" "
        onClose={() => setIsOpenNoticeModal(false)}
        onAcceptText="네, 확인했어요"
        onClick={() => {
          setIsOpenNoticeModal(false);

          if (!type) {
            navigate(SETTLEMENT_LIST_PATH, {
              state: { isRequireInvoice: true },
            });
          }
        }}
        style={{ gap: 0 }}
        buttonStyle={{ padding: '12px 24px' }}
      >
        <Row
          justifyContent="flex-start"
          style={{ padding: '16px 20px 0', width: '100%' }}
        >
          <CommonImage
            src={ICON_CLOSE}
            onClick={() => {
              setIsOpenNoticeModal(false);
            }}
          />
        </Row>
        <NoticeContainer>
          <li style={{ listStyleType: 'decimal' }}>
            <Text color="#46474c" size="16px" style={{ lineHeight: '24px' }}>
              <span style={{ fontWeight: 700 }}>
                미지급 상태의 마이너스(회수) 정산서가 있는 경우,
              </span>{' '}
              1개 주차만 따로 정산 요청할 수 없어요.
            </Text>
          </li>
          <SubNoticeContainer style={{ width: '100%' }}>
            {/* <li style={{ listStyleType: 'disc' }}>
              <Text color="#989ba2" weight={400}>
                0원 정산서: 특정 주차에 수입이 발생하지 않은 경우 생성됩니다.
              </Text>
            </li> */}
            <li style={{ listStyleType: 'disc' }}>
              <Text color="#989ba2" weight={400} style={{ lineHeight: '22px' }}>
                마이너스(회수) 정산서: 이미 정산이 완료된 상태에서 고객이 결제를
                취소하거나, 호스트가 크루에게 제공할 쿠폰 등을 구매한 경우
                발생합니다.
              </Text>
            </li>
          </SubNoticeContainer>
          <li style={{ marginTop: '12px', listStyleType: 'decimal' }}>
            <Text color="#46474c" size="16px" style={{ lineHeight: '24px' }}>
              전체보기에서 마이너스(회수) 정산서를 모두 포함한 미지급 정산서를
              전체선택했을 때,{' '}
              <span style={{ fontWeight: 700 }}>합산 금액이 0원 이상</span>
              이어야만 지급 요청을 할 수 있습니다.
            </Text>
          </li>
        </NoticeContainer>
      </ModalContainer>
    );
  };

  return (
    <React.Fragment>
      {renderContents()}
      {isOpenNoticeModal && renderNoticeModal()}
    </React.Fragment>
  );
};

export default SettlementFailedContainer;
